module.exports = __webpack_public_path__ + "static/media/button.a10669a7.svg";